const state = {
    swichdata: 0
}
const mutations = {
    SET_SWICH(state, swichdata) {
        state.swichdata = swichdata
    }
}

const actions = {

}
export default {
    namespaced: true,
    state,
    mutations,

}